import { useMemo, useRef } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { getAvailableViews } from "shared/utils/getAvailableViews";
import { isEnabled } from "../components/Permissions/permissionUtils";

const useFormRol = (initialData, onSubmit) => {
  const saving = useRef(null);
  const initialValues = useMemo(
    () => ({
      name: initialData?.name || "",
      more: {
        ...Object.fromEntries(getAvailableViews().map((view) => [view.key, false])),
        ...(initialData?.more && typeof initialData.more === "object" ? initialData.more : {}),
      },
    }),
    [initialData]
  );

  return useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: yup.object({
      name: yup.string().trim().required("El nombre del rol es requerido"),
      more: yup
        .object()
        .test("at-least-one-permission", "Seleccione al menos un permiso", (value) =>
          Object.values(value || {}).some(isEnabled)
        ),
    }),
    onSubmit: (values, { setStatus }) => {
      if (saving.current) return saving.current;
      setStatus(null);
      saving.current = Promise.resolve()
        .then(() => onSubmit({ name: values.name.trim(), more: values.more }))
        .catch((error) => {
          setStatus(error.message || "No se pudo guardar el rol. Intente nuevamente.");
        })
        .finally(() => {
          saving.current = null;
        });
      return saving.current;
    },
  });
};
export default useFormRol;
